import React from "react";
import moment from "moment";
import { ADMIN_LK, USER_LK, MESSAGE_TYPES } from "@constants";
import {
  AdminAndTime,
  ContentWrapper,
  DateText,
  Image,
  Item,
  MessageText,
  MessageWrapper,
  NameText,
  TimeText,
} from "../Message.style";
import { useSelector } from "react-redux";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { IMG_FALLBACK } from "@assets";
import { useTranslation } from "react-i18next";
import { TextWithLinks } from "@components";

const { TEXT, IMAGE, TEXT_IMAGE, AUTO_REPLY } = MESSAGE_TYPES;

const dateFormat = "D MMMM YYYY";

const Message = ({
  msgType,
  images,
  date,
  admin_name,
  text,
  time,
  sender,
  show_date,
  loading = false,
  failed = false,
}) => {
  const { t } = useTranslation();

  return (
    <Item sender={sender}>
      {show_date && <DateText>{date}</DateText>}
      <MessageWrapper>
        <ContentWrapper>
          {(msgType === TEXT ||
            msgType === TEXT_IMAGE ||
            msgType === AUTO_REPLY) && (
              <MessageText sender={sender}>
                {/* {isUrl ? <Link url={text} /> : text} */}
                <AdminAndTime sender={sender}>
                  {sender === ADMIN_LK && <NameText>{admin_name}</NameText>}
                  {!failed && (
                    <TimeText sender={sender}>
                      {loading ? t("message.sending") : time}
                    </TimeText>
                  )}
                </AdminAndTime>
                <TextWithLinks text={text} />
                {failed && <ExclamationCircleOutlined />}
              </MessageText>
            )}
          {(msgType === IMAGE || msgType === TEXT_IMAGE) &&
            images?.map((image, key) => (
              <Image key={key} src={image} fallback={IMG_FALLBACK} />
            ))}
        </ContentWrapper>
      </MessageWrapper>
    </Item>
  );
};

const ChatMessage = ({ items, item, index, device_info }) => {
  const { auth } = useSelector((state) => state);
  const { user_id } = auth.user;

  return (
    <Message
      show_date={
        moment.unix(item.sent_at).date() !==
        moment.unix(items[index + 1]?.sent_at).date()
      }
      sender={
        item.sender_id === user_id || item.sender_id === device_info
          ? USER_LK
          : ADMIN_LK
      }
      msgType={item.type}
      admin_name={item.sender_name}
      text={item.content}
      images={item.images}
      date={moment.unix(item.sent_at).format(dateFormat)}
      time={moment.unix(item.sent_at).format("LT")}
      loading={item.loading}
      failed={item.failed}
    />
  );
};

export default ChatMessage;
